import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { InstituteTypeModel } from '../model/institute-type.model';

@Injectable()
export class InstituteTypeService {

  path = '/institute-type';

  constructor(private baseService: BaseService) { }

  getPaginated(init: number, end: number) {
    return this.baseService.get(this.path, '', { init, end });
  }

  save(instituteType: InstituteTypeModel) {
    if (instituteType.id) {
      return this.put(instituteType);
    } else {
      return this.post(instituteType);
    }
  }

  post(instituteType: InstituteTypeModel) {
    return this.baseService.post(this.path, '/', instituteType);
  }

  put(instituteType: InstituteTypeModel) {
    return this.baseService.put(this.path, '/', instituteType);
  }

  delete(id: number){
    return this.baseService.delete(this.path, '/' + id);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/institute-type.service.ts